import React, { useContext } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, } from 'react-router-dom';
import { GlobalContext } from './contexts/GlobalContext';
import ScrollController from './components/ScrollController/ScrollController';
import LanguageSelector from "./components/LanguageSelector/LanguageSelector";
import Header from './components/Header/Header';
import Home from './pages/home/Home';
import About from './pages/about/About';
import Footer from './components/Footer/Footer';
import NotFound from './pages/not-found/NotFound';
import Services from './pages/services/Services';
import LoadProfile from './pages/load-profile/LoadProfile';
import Regulations from './pages/regulations/Regulations';
import Cubage from './pages/cubage/Cubage';
import ContactUs from './pages/contact-us/ContactUs';
import Certifications from './pages/certifications/Certifications';
import WorkWithUs from './pages/work-with-us/WorkWithUs';
import PrivacyPolicy from './pages/privacy-policy/PrivacyPolicy';
import SecurityRelprev from './pages/security-relprev/SecurityRelprev';
import FrequentlyAsked from './pages/frequently-asked/FrequentlyAsked'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import Cookies from './components/Cookie/Cookies';
import ConstructPage from './pages/construct-page/ConstructPage';
import BraspressInfrastructure from './pages/braspress-infrastructure/BraspressInfrastructure';
import CookiePolicy from './pages/cookie-policy/CookiePolicy';
import LGPD from './pages/LGPD/LGPD';
import History from './pages/history/History';
import Press from './pages/press/Press';
import Fleet from './pages/fleet/Fleet';
import OurStore from './pages/our-store/OurStore';
import ActiveNotice from './pages/active-notices/ActiveNotices';

const AppContent = () => {
  const { state } = useContext(GlobalContext);
  const { language } = state;

  return (
    <>
      <LanguageSelector />
      <Header />
      <Cookies />

      <Routes>
        <Route path={`/${language !== 'pt-br' ? `/${language}` : ''}`} element={<Home />} />
        <Route path={`/about${language !== 'pt-br' ? `/${language}` : ''}`} element={<About />} />
        <Route path={`/services${language !== 'pt-br' ? `/${language}` : ''}`} element={<Services />} />
        <Route path={`/load-profile${language !== 'pt-br' ? `/${language}` : ''}`} element={<LoadProfile />} />
        <Route path={`/regulations${language !== 'pt-br' ? `/${language}` : ''}`} element={<Regulations />} />
        <Route path={`/cubage${language !== 'pt-br' ? `/${language}` : ''}`} element={<Cubage />} />
        <Route path={`/contact-us${language !== 'pt-br' ? `/${language}` : ''}`} element={<GoogleReCaptchaProvider reCaptchaKey="6Leu2xYqAAAAAN7bk8PZG1r8TapPQYWTgeSFPAbH"><ContactUs /></GoogleReCaptchaProvider>} />
        <Route path={`/certifications${language !== 'pt-br' ? `/${language}` : ''}`} element={<Certifications />} />
        <Route path={`/work-with-us${language !== 'pt-br' ? `/${language}` : ''}`} element={<WorkWithUs />} />
        <Route path={`/privacy-policy${language !== 'pt-br' ? `/${language}` : ''}`} element={<PrivacyPolicy />} />
        <Route path={`/security-report${language !== 'pt-br' ? `/${language}` : ''}`} element={<GoogleReCaptchaProvider reCaptchaKey="6Leu2xYqAAAAAN7bk8PZG1r8TapPQYWTgeSFPAbH"><SecurityRelprev /></GoogleReCaptchaProvider>} />
        <Route path={`/frequently-asked${language !== 'pt-br' ? `/${language}` : ''}`} element={<FrequentlyAsked />} />

        <Route path={`/history${language !== 'pt-br' ? `/${language}` : ''}`} element={<History title={"História"} beforeRoute={"A Braspress Air Cargo"} />} />
        <Route path={`/braspress-group${language !== 'pt-br' ? `/${language}` : ''}`} element={<ConstructPage title={"Grupo Braspress"} beforeRoute={"A Braspress Air Cargo"} />} />
        {/* <Route path={`/notices${language !== 'pt-br' ? `/${language}` : ''}`} element={<ConstructPage title={"Notícias"} beforeRoute={"A Braspress Air Cargo"} />} /> */}

        <Route path={`/national-scope${language !== 'pt-br' ? `/${language}` : ''}`} element={<ConstructPage title={"Abrangência Nacional"} beforeRoute={"Diferenciais"} />} />
        <Route path={`/technology${language !== 'pt-br' ? `/${language}` : ''}`} element={<ConstructPage title={"Tecnologia"} beforeRoute={"Diferenciais"} />} />
        <Route path={`/braspress-infrastructure${language !== 'pt-br' ? `/${language}` : ''}`} element={<BraspressInfrastructure />} />

        <Route path={`/fleet${language !== 'pt-br' ? `/${language}` : ''}`} element={<Fleet beforeRoute={"Informações"} />} />
        <Route path={`/cookie-policy${language !== 'pt-br' ? `/${language}` : ''}`} element={<CookiePolicy />} />
        <Route path={`/lgpd${language !== 'pt-br' ? `/${language}` : ''}`} element={<LGPD />} />
        <Route path={`/press${language !== 'pt-br' ? `/${language}` : ''}`} element={<Press beforeRoute={"Quem Somos"} />} />
        <Route path={`/our-store${language !== 'pt-br' ? `/${language}` : ''}`} element={<OurStore beforeRoute={"Quem Somos"} />} />

        <Route
          path={`/notices${language !== 'pt-br' ? `/${language}` : ''}/:year/:month/:day/:slug`}
          element={<ActiveNotice />}
        />

        <Route path="*" element={<NotFound />} />
      </Routes>

      <Footer />
    </>
  );
}

const App = () => (
  <Router>
    <ScrollController>
      <AppContent />
    </ScrollController>
  </Router>
);

export default App;